import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectApiBaseUrl } from '~/store/env/selectors';

export default createAsyncThunk(
  'accountInfo/getSessionFromGuestLink',
  async ({ broadcastHash, guestHash }, { getState }) => {
    const apiBaseUrl = selectApiBaseUrl(getState());
    const url = `${apiBaseUrl}/auth/broadcast/guest/${broadcastHash}/${guestHash}/claim`;

    const params = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-API-VERSION': '2.0',
      },
    };
    const response = await fetch(url, params);

    if (!response.ok) {
      throw await response.text();
    }

    return response.json();
  }
);
